import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/' },
  { label: 'Alerts', path: '/alerts' },
  { label: 'Shift History', path: '/shifts' },
];

export default function AppHeader() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header style={styles.header}>
      <div style={styles.inner}>
        <div style={styles.left}>
          <img
            src="/vision-full-logo.png"
            alt="Vision"
            style={styles.logo}
            onClick={() => navigate('/')}
          />
        </div>

        <nav style={styles.right}>
          {NAV_ITEMS.map(item => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                ...styles.navLink,
                ...(isActive(item.path) ? styles.navLinkActive : {}),
              }}
            >
              {item.label}
            </button>
          ))}
          {isAdmin && (
            <button
              onClick={() => navigate('/admin')}
              style={{
                ...styles.navLink,
                ...(isActive('/admin') ? styles.navLinkActive : {}),
              }}
            >
              Admin
            </button>
          )}

          <div style={styles.divider} />

          <span style={styles.email}>{user?.email}</span>
          <button onClick={logout} style={styles.signOut}>
            Sign Out
          </button>
        </nav>
      </div>
    </header>
  );
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: 72,
    background: 'var(--bg-surface)',
    borderBottom: '1px solid var(--border-subtle)',
    zIndex: 100,
  },
  inner: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: 44,
    cursor: 'pointer',
    userSelect: 'none' as const,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  navLink: {
    fontFamily: 'var(--font-body)',
    fontSize: 'var(--text-sm)',
    fontWeight: 500,
    color: 'var(--text-secondary)',
    background: 'none',
    border: 'none',
    padding: '6px 10px',
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
    transition: 'color 0.15s, background 0.15s',
    whiteSpace: 'nowrap' as const,
  },
  navLinkActive: {
    color: 'var(--accent-text)',
    background: 'var(--accent-muted)',
  },
  divider: {
    width: 1,
    height: 20,
    background: 'var(--border-subtle)',
    margin: '0 8px',
  },
  email: {
    fontFamily: 'var(--font-body)',
    fontSize: 'var(--text-xs)',
    color: 'var(--text-tertiary)',
    maxWidth: 160,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  signOut: {
    fontFamily: 'var(--font-body)',
    fontSize: 'var(--text-xs)',
    fontWeight: 500,
    color: 'var(--text-secondary)',
    background: 'none',
    border: '1px solid var(--border-default)',
    padding: '4px 10px',
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
    transition: 'border-color 0.15s, color 0.15s',
    marginLeft: 4,
  },
};
